import { createElement } from 'react';
import { node, string, bool } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'reakit/List';
import '../List/styled.js';
import '../List/ListItem.js';
import '../List/index.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import 'reakit/Link';
import '../Link/styled.js';
import '../Link/index.js';
import { BreadcrumbStep as BreadcrumbStep$1, BreadcrumbLink, BreadcrumbSpan } from './styled.js';

/* eslint react/prop-types: 0 */
var BreadcrumbStep = function BreadcrumbStep(_ref) {
  var children = _ref.children,
      color = _ref.color,
      href = _ref.href,
      isCurrent = _ref.isCurrent;
  return createElement(BreadcrumbStep$1, null, href ? createElement(BreadcrumbLink, {
    "aria-current": isCurrent ? 'page' : undefined,
    color: color,
    href: href
  }, children) : createElement(BreadcrumbSpan, {
    "aria-current": isCurrent ? 'page' : undefined,
    color: color
  }, children));
};
var breadcrumbStepPropTypes = {
  children: node.isRequired,
  color: string,
  href: string,
  isCurrent: bool
};
BreadcrumbStep.propTypes = breadcrumbStepPropTypes;
var breadcrumbStepDefaultProps = {
  color: undefined,
  href: undefined,
  isCurrent: undefined
};
BreadcrumbStep.defaultProps = breadcrumbStepDefaultProps; // @ts-ignore

var C = BreadcrumbStep;

export default C;
export { BreadcrumbStep, breadcrumbStepDefaultProps, breadcrumbStepPropTypes };
